import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";

export const genericFilterOperatorReducer = (state = initialState.genericFilterOperators, action) => {
  const context = action.context;
  switch (action.type) {
    case types.LOAD_GENERICFILTEROPERATORS_STARTED: {
      return { ...state, [context]: { ...state[context], genericFilterOperators: { loading: true, loaded: false } } };
    }

    case types.LOAD_GENERICFILTEROPERATORS_SUCCEEDED: {
      return {
        ...state,
        [context]: {
          ...state[context],
          genericFilterOperators: { loading: false, loaded: true, ids: [...action.result] }
        }
      };
    }

    case types.LOAD_GENERICFILTEROPERATORS_FAILED: {
      return { ...state, [context]: { ...state[context], genericFilterOperators: { loading: false, loaded: false } } };
    }

    default:
      return state;
  }
};
